"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _GREGORIAN_ALL_WEEK_NAME = _interopRequireDefault(require("@lumirental/lumi-web-sdk/dist/constants/date/GREGORIAN_ALL_WEEK_NAME"));
var _getArabicFullDayNameOfWeek = _interopRequireDefault(require("../getArabicFullDayNameOfWeek"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * returns the arabic day with label eg: 'monday - tuesday' to 'الاثنين - يوم الثلاثاء'
 * @param {String} enDay
 * @returns {String}
 */
function getArabicDayWithLabel(enDay) {
  var splitValue = enDay.split(' - ');
  var formatedDay;
  if (splitValue.length > 1) {
    formatedDay = splitValue.map(function (value) {
      return (0, _getArabicFullDayNameOfWeek["default"])(value);
    }).join(' - ');
  } else if (splitValue[0] === _GREGORIAN_ALL_WEEK_NAME["default"].EN[0]) {
    var dayIndex = _GREGORIAN_ALL_WEEK_NAME["default"].EN.indexOf(splitValue[0]);
    formatedDay = _GREGORIAN_ALL_WEEK_NAME["default"].AR[dayIndex];
  } else {
    formatedDay = (0, _getArabicFullDayNameOfWeek["default"])(splitValue[0]);
  }
  return formatedDay;
}
var _default = exports["default"] = getArabicDayWithLabel;